import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f7040d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "tw-max-w-[1300px] tw-w-full"
}
const _hoisted_3 = { class: "tw-w-full tw-rounded-lg tw-bg-[#F8FBFD] tw-border-solid tw-border-[1px] tw-border-[#DFDFDF] tw-p-4 tw-box-border tw-flex tw-flex-col tw-gap-3" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-justify-between tw-pb-3 tw-box-border tw-border-b-dashed-custom" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-2 tw-justify-start" }
const _hoisted_6 = { class: "tw-w-full tw-flex tw-flex-col tw-gap-4 md:!tw-gap-3" }
const _hoisted_7 = { class: "tw-rounded-[4px] tw-border-[1px] tw-border-solid tw-border-[#DFDFDF] tw-min-w-[48px] tw-w-[48px] tw-h-[48px] tw-flex tw-items-center tw-justify-center tw-bg-white" }
const _hoisted_8 = { class: "tw-rounded-full tw-w-[34px] tw-min-w-[34px] tw-h-[34px] tw-bg-[#E7F4FE] tw-flex tw-items-center tw-justify-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "tw-w-full tw-items-center tw-flex tw-justify-start"
}
const _hoisted_11 = {
  key: 1,
  class: "tw-w-full tw-flex tw-flex-col tw-items-start tw-gap-1"
}
const _hoisted_12 = { class: "tw-w-full tw-flex tw-flex-wrap tw-h-auto tw-gap-2" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2 md:!tw-gap-1"
}
const _hoisted_15 = {
  key: 2,
  class: "empty__content !tw-pb-12 !tw-box-border !tw-h-auto tw-w-full"
}
const _hoisted_16 = { class: "empty__banner tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4" }
const _hoisted_17 = { class: "empty__banner__img md:!tw-w-[50%]" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 0,
  class: "empty__banner__content"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "You don't have any services yet!", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " It looks like you haven't added any services yet. Add your offerings to connect with property owners and showcase your skills. ", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "empty__banner__content"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Don't have any services yet!", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "It looks like you haven't added any services to your profile yet.", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "empty__banner__footer tw-w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Text = _resolveComponent("Text")!
  const _component_PendingVerifyNotice = _resolveComponent("PendingVerifyNotice")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BlueCircularPencilIcon = _resolveComponent("BlueCircularPencilIcon")!
  const _component_GrayCircularTrashIcon = _resolveComponent("GrayCircularTrashIcon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_SpecialismEditModal = _resolveComponent("SpecialismEditModal")!
  const _component_SpecialismMultiSelectModel = _resolveComponent("SpecialismMultiSelectModel")!
  const _component_AddNewTradeSpecialism = _resolveComponent("AddNewTradeSpecialism")!
  const _component_ConfirmDeleteModal = _resolveComponent("ConfirmDeleteModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Loader, {
            show: $setup.isLoading,
            class: "tw-z-10"
          }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onRouteToTradePassport && $setup.onRouteToTradePassport(...args))),
      class: "tw-flex tw-items-center tw-gap-[.1rem] tw-cursor-pointer tw-pb-4 tw-w-full"
    }, [
      _createVNode(_component_v_icon, { icon: "mdi-chevron-left" }),
      _createVNode(_component_Text, {
        variant: "p",
        textWeight: "600"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Back")
        ]),
        _: 1
      })
    ]),
    (!$setup.isLoading && $setup.userSpecialismList?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (
        $setup.userSkillVerificationStatus?.userVerificationStatus ===
          $setup.UserVerificationStatusEnum.PENDING_VERIFICATION &&
        $setup.isWorkStationVerified &&
        !$setup.isUserProprtyOwner
      )
            ? (_openBlock(), _createBlock(_component_PendingVerifyNotice, {
                key: 0,
                content: "New services are being verified. Use existing ones."
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Text, {
                  variant: "h6",
                  class: "rmd:!tw-text-[22px]",
                  lineHeight: "18px",
                  textAlign: "left"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.isUserProprtyOwner ? "Services" : "Your Services"), 1)
                  ]),
                  _: 1
                })
              ]),
              (!$setup.isUserProprtyOwner)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    variant: "secondary",
                    label: "+Add Services",
                    class: "!tw-w-auto md:!tw-min-h-[unset] md:!tw-px-2",
                    onClick: $setup.onClickToggleSpecialismForm
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userSpecialismList, (skill, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "tw-w-full tw-flex tw-items-start tw-gap-4 md:!tw-gap-2",
                  key: index
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-border-[1px] tw-border-[#DFDFDF] tw-border-solid tw-bg-white tw-p-4 tw-box-border", { '!tw-items-start': $setup.collapsedItems.includes(index) }])
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: 
                    require(`@/assets/category-icons/${skill?.category?.iconName}.svg`)
                  ,
                          class: "tw-w-[15px] tw-min-w-[15px] tw-h-[15px] tw-object-contain"
                        }, null, 8, _hoisted_9)
                      ])
                    ]),
                    (!$setup.collapsedItems.includes(index))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_Text, {
                            variant: "h6",
                            textAlign: "left"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(skill.label), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_Text, {
                            variant: "h6",
                            textAlign: "left",
                            class: "md:!tw-text-[.8rem]"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(skill.label), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.subCategories, (subCategory, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "tw-w-auto tw-py-[.1rem] tw-px-2 tw-rounded-[5.33px] tw-box-border tw-bg-[#E7F4FE] tw-flex tw-items-center tw-justify-center"
                              }, [
                                _createVNode(_component_Text, {
                                  variant: "xsmall",
                                  textAlign: "left"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(subCategory.label), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            }), 128))
                          ])
                        ])),
                    _createElementVNode("div", {
                      onClick: ($event: any) => ($setup.onToggleCollapsedState(index)),
                      class: "tw-min-w-[26px] tw-w-[26px] tw-h-[26px] tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border-[1.3px] tw-border-solid tw-border-[#DFDFDF] tw-bg-[#F8FBFD] tw-cursor-pointer"
                    }, [
                      (!$setup.collapsedItems.includes(index))
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            icon: "mdi-chevron-right",
                            class: "!tw-text-[14px]"
                          }))
                        : (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            icon: "mdi-chevron-down",
                            class: "!tw-text-[14px]"
                          }))
                    ], 8, _hoisted_13)
                  ], 2),
                  ($setup.getUserWorkStationFieldAccess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (!$setup.isUserProprtyOwner)
                          ? (_openBlock(), _createBlock(_component_BlueCircularPencilIcon, {
                              key: 0,
                              class: "md:!tw-min-w-[21px] md:!tw-w-[21px] md:!tw-h-[21px]",
                              onClick: ($event: any) => ($setup.editSpecialism(skill))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (!$setup.isUserProprtyOwner)
                          ? (_openBlock(), _createBlock(_component_GrayCircularTrashIcon, {
                              key: 1,
                              class: "md:!tw-min-w-[21px] md:!tw-w-[21px] md:!tw-h-[21px]",
                              onClick: ($event: any) => ($setup.onDeleteItem(skill.id))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!$setup.isLoading && !$setup.userSpecialismList?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", {
                src: require('../../../assets/images/trade-services-empty.png'),
                alt: "",
                class: "tw-w-full"
              }, null, 8, _hoisted_18)
            ]),
            (!$setup.isUserProprtyOwner)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26)),
            _createElementVNode("div", _hoisted_27, [
              ($setup.getUserWorkStationFieldAccess && !$setup.isUserProprtyOwner)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    onClick: $setup.onClickToggleSpecialismForm,
                    class: "button button-purple",
                    width: "100%"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("add new trade Services")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.isShowEditSpecialismModal)
      ? (_openBlock(), _createBlock(_component_SpecialismEditModal, {
          key: 3,
          onOnClickCancel: $setup.onClickCloseEditModal,
          userSpecialismData: $setup.userSpecialismData
        }, null, 8, ["onOnClickCancel", "userSpecialismData"]))
      : _createCommentVNode("", true),
    ($setup.isShowSpecialismModal)
      ? (_openBlock(), _createBlock(_component_SpecialismMultiSelectModel, {
          key: 4,
          onOnClickAddNewTradeSpecialism: $setup.onClickAddNewTradeSpecialism,
          onOnClickCancel: $setup.closeSpecialismMultiSelectModel
        }, null, 8, ["onOnClickAddNewTradeSpecialism", "onOnClickCancel"]))
      : _createCommentVNode("", true),
    ($setup.isShowAddNewTradeSpecialism)
      ? (_openBlock(), _createBlock(_component_AddNewTradeSpecialism, {
          key: 5,
          onOnClickCancelButton: $setup.closeAddNewTradeSpecialism
        }, null, 8, ["onOnClickCancelButton"]))
      : _createCommentVNode("", true),
    ($setup.isOpenConfirmDelete)
      ? (_openBlock(), _createBlock(_component_ConfirmDeleteModal, {
          key: 6,
          label: "You're about to delete your service.",
          onOnClose: $setup.onCloseConfirmDelete,
          onOnDelete: $setup.onClickDeleteSpecialism,
          loading: $setup.deleteLoader
        }, null, 8, ["onOnClose", "onOnDelete", "loading"]))
      : _createCommentVNode("", true)
  ], 64))
}